export const create = {
  createSuccessfully: 'ユニフォーム情報作成は完了しました。',
}
